// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"c2bf7f7a","297":"a9a7bbd9"}[chunkId] + ".chunk.js";
};